<!--
 * @Description: 客户代码下拉选择框
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-09 15:17:13
 * @LastEditors: mdb
-->
<template>
  <CosSelect
    v-model:value="data"
    v-bind="$attrs"
    style="width: 100%"
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="fetchCode"
    :placeholder="t('common.pleaseSelect')"
    @change="change"
    :view="view"
    :fieldNames="{ label: 'arkCode', value: 'id' }"
    :options="optionPage"
  >
  </CosSelect>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SelectProps } from 'ant-design-vue'
import { getCosIdBindCode as getCosIdBindCodeFbu } from '@/api/gucangSales/customerCenter'
import { getCosIdBindCode as getCosIdBindCodeOfbu } from '@/api/overseasSales/customerCenter'
import { debounce } from 'lodash-es'
const { t } = useI18n()

const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  label: String,
  cosId: {
    type: String
  },
  view: {
    type: Boolean
  },
  stage: {
    type: Array,
    default: () => {
      return [2, 3, 4] // 2.潜在 3签约 4 成交
    }
  },
  requiredCosId: {
    type: Boolean,
    default: true
  },
  isEmpty: {
    type: Boolean,
    default: false
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
})
const getCosIdBindCodeMethod = {
  cos_fbu: getCosIdBindCodeFbu,
  cos_ofbu: getCosIdBindCodeOfbu
}
const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = defineEmits(['update:value', 'update:label', 'update:isEmpty'])
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.cosId,
  (v, prev) => {
    if (v && v !== prev) {
      optionPage.value = []
      if (prev) {
        data.value = undefined
        emit('update:label', undefined)
        emit('update:value', undefined)
      }
      fetch()
    }
  }
)
const change: SelectProps['onChange'] = (value) => {
  const find = optionPage.value.find((item) => item.id === value)
  emit('update:label', find?.arkCode)
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const fetchCode = debounce((txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  getCosIdBindCodeMethod[props.appId]({
    pageNumber: pageNumber.value,
    pageSize: 100,
    stage: props.stage,
    cosId: props.cosId
  }).then((res: any) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
    emit('update:isEmpty', optionPage.value.length === 0)

    // 详情页回显的时候，判断下拉列表中是否包含当前值，如果没有，则将详情数据添加到列表并设置不可选
    if (props.label && props.value) {
      const find = optionPage.value.find((item) => item.id === props.value)
      if (!find) optionPage.value.unshift({ id: props.value, arkCode: props.label, disabled: true })
    }
  })
}
onMounted(() => {
  if (props.requiredCosId && !props.cosId) {
    return
  }
  fetch()
})
</script>
<script lang="ts">
export default { name: 'CodeSelect' }
</script>
